import { defineComponent as _defineComponent } from 'vue'
import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import {
  AccountingPeriod,
  TransactionType,
} from "@/Enums";

import {
  defaultFetch,
  httpMethod,
} from "@/scripts/Common/api";

import {
  copyObject,
} from "@/scripts/Common/HelperFunctions";

import {
  computed,
  PropType,
  ref,
  unref,
} from "vue";

import {
  SepaSettings,
} from "@/components/settings/scripts/Sepas";

import {
  useI18n,
} from "@/composables/useI18n";

import {
  hasAccessRights,
} from "@/authorization/AuthorizationService";

import {
  editSettingsPolicy,
} from "@/authorization/policies";


export default /*#__PURE__*/_defineComponent({
  __name: 'SepaOtherSettings',
  props: {
  token: {
    required: true,
    type: String as PropType<string>,
  }
},
  emits: [
  'onSuccessfulUpdate',
  'onError',
],
  setup(__props, { emit: emits }) {

const props = __props;



const {
  t
} = useI18n();



const sepaSettings = ref<SepaSettings>({
  type: TransactionType.all,
  creditAccountingPeriod: AccountingPeriod.daily,
  debitAccountingPeriod: AccountingPeriod.daily
});
const serverSepaSettings = ref<SepaSettings>();

const accountingPeriodSelection = computed(() => [
  {state: t('option_daily'), value: AccountingPeriod.daily},
  {state: t('option_weekly'), value: AccountingPeriod.weekly},
  {state: t('option_biweekly'), value: AccountingPeriod.biweekly},
  {state: t('option_monthly'), value: AccountingPeriod.monthly}
]);

const settingsHaveChanges = computed (() => {
  return sepaSettings.value.type !== serverSepaSettings.value?.type
    || sepaSettings.value.creditAccountingPeriod !== serverSepaSettings.value?.creditAccountingPeriod
    || sepaSettings.value.debitAccountingPeriod !== serverSepaSettings.value?.debitAccountingPeriod;
});

const fetchSepaSettings = async () => {
  if(sepaSettings.value.type === TransactionType.other) return;

  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'sepaOtherSettingsResource',
    bearer: props.token
  });

  if (error) {
    emits('onError', {error});
    return;
  }

  sepaSettings.value = response;
  serverSepaSettings.value = copyObject(response);
};

const updateSepaSettings = async () => {
  const {
    error,
    response,
  } = await defaultFetch({
    apiName: 'sepaOtherSettingsResource',
    bearer: props.token,
    options: {
      method: httpMethod.PUT
    },
    body: JSON.stringify(unref(sepaSettings)),
  });

  if (error) {
    emits('onError', {error});
    return;
  }

  sepaSettings.value = response;
  serverSepaSettings.value = copyObject(response);
  emits('onSuccessfulUpdate');
};

const onHandleClickSave = () => {
  updateSepaSettings();
}

const onHandleClickReset = () => {
  sepaSettings.value = copyObject(serverSepaSettings.value);
}

return { __sfc: true,props, t, emits, sepaSettings, serverSepaSettings, accountingPeriodSelection, settingsHaveChanges, fetchSepaSettings, updateSepaSettings, onHandleClickSave, onHandleClickReset, FloatingActionButton, hasAccessRights, editSettingsPolicy }
}

})